import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../pages/Login";
import Dashboard from "../pages/dashboard/index.jsx";
import Contacts from "../pages/contacts/index.jsx";
import Calendar from "../pages/calendar/index.jsx";
import Team from "../pages/team/index.jsx";
import Invoices from "../pages/invoices/index.jsx";
import Form from "../pages/form/index.jsx";
import FAQ from "../pages/faq/index.jsx";
import AddBanner from "../pages/homeBanner/index.jsx";
import BannerList from "../pages/homeBanner/BannerList.jsx";
import TechPatientsList from "../pages/TechPatient/TechPatientsList.jsx";
import AddTechPatient from "../pages/TechPatient/AddTechPatient.jsx";
import AddPatientStory from "../pages/PatientStory/AddPatientStory.jsx";
import PatientStoriesList from "../pages/PatientStory/PatientStoriesList.jsx";
import AddUpcomingEvent from "../pages/Events/AddUpcomingEvent.jsx";
import UpcomingEventsList from "../pages/Events/UpcomingEventsList.jsx";
import AddBetterInfoHealth from "../pages/BetterInfoHealth/AddBetterInfoHealth.jsx";
import BetterInfoHealthList from "../pages/BetterInfoHealth/BetterInfoHealthList.jsx";
import AddDoctors from "../pages/Doctors/AddDoctors.jsx";
import ListDoctors from "../pages/Doctors/ListDoctors.jsx";
import AddSpecialties from "../pages/Specialties/AddSpecialties.jsx";
import ListSpecialties from "../pages/Specialties/ListSpecialties.jsx";
import ProtectedRoute from "./ProtectedRoute";
import AddWhyChooseRaheja from "../pages/aboutPage/AddWhyChooseRaheja.jsx";
import WhyChooseRahejaList from "../pages/aboutPage/WhyChooseRahejaList.jsx";
import AwardsAccoladesList from "../pages/aboutPage/AwardsAccoladesList.jsx";
import AddAwardsAccolades from "../pages/aboutPage/AddAwardsAccolades.jsx";
import AddCareerJob from "../pages/Careers/AddCareerJob.jsx";
import CareerJobs from "../pages/Careers/CareerJobs.jsx";
import AddCareerAtRaheja from "../pages/Careers/AddCareerAtRaheja.jsx";
import ListCareerAtRaheja from "../pages/Careers/ListCareerAtRaheja.jsx";
import AddContactInfo from "../pages/ContactPage/AddContactInfo.jsx";
import ListContactInfo from "../pages/ContactPage/ListContactInfo.jsx";
import ListHealthCheckup from "../pages/HealthCheckup/ListHealthCheckup.jsx";
import AddHealthCheckup from "../pages/HealthCheckup/AddHealthCheckup.jsx";
import AddHealthCheckupPackage from "../pages/HealthCheckup/AddHealthCheckupPackage.jsx";
import ListHealthCheckupPackage from "../pages/HealthCheckup/ListHealthCheckupPackage.jsx";
import AddHealthCheckupTestInclusion from "../pages/HealthCheckup/AddHealthCheckupTestInclusion.jsx";
import ListHealthCheckupTestInclusion from "../pages/HealthCheckup/ListHealthCheckupTestInclusion.jsx";
import AddAcademicsOverview from "../pages/Academics/AddAcademicsOverview.jsx";
import ListAcademicsOverview from "../pages/Academics/ListAcademicsOverview.jsx";
import AddAcademicsProgramDetails from "../pages/Academics/AddAcademicsProgramDetails.jsx";
import ListAcademicsProgramDetails from "../pages/Academics/ListAcademicsProgramDetails.jsx";
import AddBannerCMS from "../pages/Banners/AddBannerCMS.jsx";
import ListBanners from "../pages/Banners/ListBanners.jsx";
import AddBlog from "../pages/Blogs/AddBlog.jsx";
import BlogsList from "../pages/Blogs/BlogsList.jsx";
import AddFaq from "../pages/faq/AddFaq.jsx";
import FaqList from "../pages/faq/FaqList.jsx";
import SpecialityFaqList from "../pages/Specialties/SpecialityFaqList.jsx";
import CorporateTpaList from "../pages/corporateTpa/CorporateTpaList.jsx";
import ListOpdSchedulePdf from "../pages/OPDSchedule/ListOpdSchedulePdf.jsx";
import AddHospitalTour from "../pages/TakeATour/AddHospitalTour.jsx";
import ListHospitalTour from "../pages/TakeATour/ListHospitalTour.jsx";
import ListAppointments from "../pages/contacts/ListAppointments.jsx";
import ListInternationalContacts from "../pages/contacts/ListInternationalContacts.jsx";
import ListRequestCallbacks from "../pages/contacts/ListRequestCallbacks.jsx";
import ListSubscriptions from "../pages/contacts/ListSubscriptions.jsx";
import HomeCardList from "../pages/HomePage/HomeCardList.jsx";
import HomePageDoctors from "../pages/HomePage/HomePageDoctors.jsx";
import HomePageSpecialty from "../pages/HomePage/HomePageSpecialty.jsx";
import HomeCorporateLogos from "../pages/HomePage/HomeCorporateLogos.jsx";
import HomeTPAEmpanelledLogos from "../pages/HomePage/HomeTPAEmpanelledLogos.jsx";
import HomeAboutSLRaheja from "../pages/HomePage/HomeAboutSLRaheja.jsx";
import RedirectOnInvalidRoute from "./RedirectOnInvalidRoute.jsx";
import HomePageInternationalBanner from "../pages/HomePage/HomePageInternationalBanner.jsx";
import HeaderContactNumber from "../pages/HomePage/HeaderContactNumber.jsx";
import InternationalHealthCare from "../pages/International Patients/InternationalHealthCare.jsx";
import InternationalSpecialty from "../pages/International Patients/InternationalSpecialities.jsx";
import InternationalDoctors from "../pages/International Patients/InternationalDoctors.jsx";
import InternationalStatics from "../pages/International Patients/InternationalStatics.jsx";
import InternationalWhychooseUs from "../pages/International Patients/InternationalWhyChooseUs.jsx";
import InternationalInsurance from "../pages/International Patients/InternationalInsurance.jsx";
import InternationalOurServices from "../pages/International Patients/InternationalOurServices.jsx";
import SeoTagList from "../pages/seoTagList/seoTagList.jsx";
import { AdvancedMedicalEquipmentCategoryList } from "../pages/HospitalTechnology/AdvanceMedicalEquipmentCategoryList.jsx";
import { AdvancedMedicalEquipmentDetailsList } from "../pages/HospitalTechnology/AdvancedMedicalEquipmentDetailsList.jsx";
import { HospitalServicesDetailsList } from "../pages/HospitalTechnology/HospitalServicesDetailsList.jsx";
import { HospitalHomeCareServicesList } from "../pages/HospitalTechnology/HospitalHomeCareServicesList.jsx";
import { HospitalOtherServicesList } from "../pages/HospitalTechnology/HospitalOtherServicesList.jsx";
import ListSpecialistDoctors from "../pages/Specialties/ListSpecialistDoctors.jsx";
import AboutUsContentList from "../pages/aboutPage/AboutUsContentList.jsx";
import RegulatoryCompliance from "../pages/Compliance/RegulatoryCompliance.jsx";
import ProcedureList from "../pages/Procedures/ProcedureList.jsx";
import AddProcedure from "../pages/Procedures/AddProcedure.jsx";
import ProcedureFaqList from "../pages/Procedures/ProcedureFaqList.jsx";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<ProtectedRoute element={<Dashboard />} />} />
      <Route
        path="/contacts"
        element={<ProtectedRoute element={<Contacts />} />}
      />
      <Route
        path="/calendar"
        element={<ProtectedRoute element={<Calendar />} />}
      />
      <Route path="/team" element={<ProtectedRoute element={<Team />} />} />
      <Route
        path="/invoices"
        element={<ProtectedRoute element={<Invoices />} />}
      />
      <Route path="/form" element={<ProtectedRoute element={<Form />} />} />
      <Route path="/faq" element={<ProtectedRoute element={<FAQ />} />} />
      <Route
        path="/add-banner"
        element={<ProtectedRoute element={<AddBanner />} />}
      />
      <Route
        path="/banners-list"
        element={<ProtectedRoute element={<BannerList />} />}
      />
      ;
      <Route
        path="/tech-patients"
        element={<ProtectedRoute element={<TechPatientsList />} />}
      />
      ;
      <Route
        path="/add-tech-patient"
        element={<ProtectedRoute element={<AddTechPatient />} />}
      />
      ;
      <Route
        path="/add-patient-story"
        element={<ProtectedRoute element={<AddPatientStory />} />}
      />
      ;
      <Route
        path="/patient-stories"
        element={<ProtectedRoute element={<PatientStoriesList />} />}
      />
      ;
      <Route
        path="/corporate-tpa"
        element={<ProtectedRoute element={<CorporateTpaList />} />}
      />
      <Route
        path="/add-upcoming-event"
        element={<ProtectedRoute element={<AddUpcomingEvent />} />}
      />
      <Route
        path="/upcoming-event-list"
        element={<ProtectedRoute element={<UpcomingEventsList />} />}
      />
      <Route
        path="/add-better-info-health"
        element={<ProtectedRoute element={<AddBetterInfoHealth />} />}
      />
      <Route
        path="/list-better-info-health"
        element={<ProtectedRoute element={<BetterInfoHealthList />} />}
      />
      <Route
        path="/add-doctor"
        element={<ProtectedRoute element={<AddDoctors />} />}
      />
      <Route
        path="/list-doctors"
        element={<ProtectedRoute element={<ListDoctors />} />}
      />
      <Route
        path="/add-specialties"
        element={<ProtectedRoute element={<AddSpecialties />} />}
      />
      <Route
        path="/list-specialties"
        element={<ProtectedRoute element={<ListSpecialties />} />}
      />
      <Route
        path="/order-specialties"
        element={<ProtectedRoute element={<ListSpecialistDoctors />} />}
      />
      <Route
        path="/faq-specialties"
        element={<ProtectedRoute element={<SpecialityFaqList />} />}
      />
      <Route
        path="/about-us-content-list"
        element={<ProtectedRoute element={<AboutUsContentList />} />}
      />
      <Route
        path="/about-us-content-list"
        element={<ProtectedRoute element={<AboutUsContentList />} />}
      />
      <Route
        path="/add-why-slraheja"
        element={<ProtectedRoute element={<AddWhyChooseRaheja />} />}
      />
      <Route
        path="/about-why-slraheja-list"
        element={<ProtectedRoute element={<WhyChooseRahejaList />} />}
      />
      <Route
        path="/awards-accolades-list"
        element={<ProtectedRoute element={<AwardsAccoladesList />} />}
      />
      <Route
        path="/add-awards-accolades"
        element={<ProtectedRoute element={<AddAwardsAccolades />} />}
      />
      <Route
        path="/add-career-job"
        element={<ProtectedRoute element={<AddCareerJob />} />}
      />
      <Route
        path="/career-jobs"
        element={<ProtectedRoute element={<CareerJobs />} />}
      />
      <Route
        path="/add-career-at-raheja"
        element={<ProtectedRoute element={<AddCareerAtRaheja />} />}
      />
      <Route
        path="/list-career-at-raheja"
        element={<ProtectedRoute element={<ListCareerAtRaheja />} />}
      />
      <Route
        path="/add-contact-info"
        element={<ProtectedRoute element={<AddContactInfo />} />}
      />
      <Route
        path="/list-contact-info"
        element={<ProtectedRoute element={<ListContactInfo />} />}
      />
      <Route
        path="/list-health-checkup"
        element={<ProtectedRoute element={<ListHealthCheckup />} />}
      />
      <Route
        path="/add-health-checkup"
        element={<ProtectedRoute element={<AddHealthCheckup />} />}
      />
      <Route
        path="/add-health-checkup-package"
        element={<ProtectedRoute element={<AddHealthCheckupPackage />} />}
      />
      <Route
        path="/list-health-checkup-package"
        element={<ProtectedRoute element={<ListHealthCheckupPackage />} />}
      />
      <Route
        path="/add-health-checkup-test-inclusion"
        element={<ProtectedRoute element={<AddHealthCheckupTestInclusion />} />}
      />
      <Route
        path="/list-health-checkup-test-inclusion"
        element={
          <ProtectedRoute element={<ListHealthCheckupTestInclusion />} />
        }
      />
      <Route
        path="/add-academics-overview"
        element={<ProtectedRoute element={<AddAcademicsOverview />} />}
      />
      <Route
        path="/list-academics-overview"
        element={<ProtectedRoute element={<ListAcademicsOverview />} />}
      />
      <Route
        path="/add-academics-program-details"
        element={<ProtectedRoute element={<AddAcademicsProgramDetails />} />}
      />
      <Route
        path="/list-academics-program-details"
        element={<ProtectedRoute element={<ListAcademicsProgramDetails />} />}
      />
      <Route
        path="/add-bannerscms"
        element={<ProtectedRoute element={<AddBannerCMS />} />}
      />
      <Route
        path="/list-bannerscms"
        element={<ProtectedRoute element={<ListBanners />} />}
      />
      <Route
        path="/add-blog"
        element={<ProtectedRoute element={<AddBlog />} />}
      />
      <Route
        path="/blogs-list"
        element={<ProtectedRoute element={<BlogsList />} />}
      />
      <Route
        path="/opd-schedule-pdf"
        element={<ProtectedRoute element={<ListOpdSchedulePdf />} />}
      />
      <Route
        path="/add-faq"
        element={<ProtectedRoute element={<AddFaq />} />}
      />
      <Route
        path="/faq-list"
        element={<ProtectedRoute element={<FaqList />} />}
      />
      <Route
        path="/add-take-a-tour"
        element={<ProtectedRoute element={<AddHospitalTour />} />}
      />
      <Route
        path="/list-take-a-tour"
        element={<ProtectedRoute element={<ListHospitalTour />} />}
      />
      <Route
        path="/list-health-checkup-leads"
        element={<ProtectedRoute element={<ListAppointments />} />}
      />
      <Route
        path="/list-international"
        element={<ProtectedRoute element={<ListInternationalContacts />} />}
      />
      <Route
        path="/list-doctor-appointments"
        element={<ProtectedRoute element={<ListRequestCallbacks />} />}
      />
      <Route
        path="/list-subscribers"
        element={<ProtectedRoute element={<ListSubscriptions />} />}
      />
      <Route
        path="/list-take-a-tour"
        element={<ProtectedRoute element={<ListHospitalTour />} />}
      />
      <Route
        path="/international-patients"
        element={<ProtectedRoute element={<InternationalHealthCare />} />}
      />
      <Route
        path="/international-specialty"
        element={<ProtectedRoute element={<InternationalSpecialty />} />}
      />
      <Route
        path="/international-doctors"
        element={<ProtectedRoute element={<InternationalDoctors />} />}
      />
      <Route
        path="/international-statics"
        element={<ProtectedRoute element={<InternationalStatics />} />}
      />
      <Route
        path="/international-Why choose Us"
        element={<ProtectedRoute element={<InternationalWhychooseUs />} />}
      />
      <Route
        path="/international-insurance"
        element={<ProtectedRoute element={<InternationalInsurance />} />}
      />
      <Route
        path="/international-ourservices"
        element={<ProtectedRoute element={<InternationalOurServices />} />}
      />
      <Route
        path="/seo-tag-list"
        element={<ProtectedRoute element={<SeoTagList />} />}
      />
      <Route
        path="/list-homecards"
        element={<ProtectedRoute element={<HomeCardList />} />}
      />
      <Route
        path="/homepage-doctors"
        element={<ProtectedRoute element={<HomePageDoctors />} />}
      />
      <Route
        path="/homepage-specialty"
        element={<ProtectedRoute element={<HomePageSpecialty />} />}
      />
      <Route
        path="/homepage-corporate"
        element={<ProtectedRoute element={<HomeCorporateLogos />} />}
      />
      <Route
        path="/homepage-tpaempanelled"
        element={<ProtectedRoute element={<HomeTPAEmpanelledLogos />} />}
      />
      <Route
        path="/homepage-aboutslraheja"
        element={<ProtectedRoute element={<HomeAboutSLRaheja />} />}
      />
      <Route
        path="/homepage-international-banner"
        element={<ProtectedRoute element={<HomePageInternationalBanner />} />}
      />
      <Route
        path="/header-phone-number"
        element={<ProtectedRoute element={<HeaderContactNumber />} />}
      />
      <Route
        path="/advance-med-equipment-list"
        element={<ProtectedRoute element={<AdvancedMedicalEquipmentCategoryList />} />}
      />
      <Route
        path="/advance-med-equipment-details-list"
        element={<ProtectedRoute element={<AdvancedMedicalEquipmentDetailsList />} />}
      />
      <Route
        path="/hospital-services-details-list"
        element={<ProtectedRoute element={<HospitalServicesDetailsList />} />}
      />
      <Route
        path="/hospitla-homecare-services-list"
        element={<ProtectedRoute element={<HospitalHomeCareServicesList />} />}
      />
      <Route
        path="/hospital-other-services-list"
        element={<ProtectedRoute element={<HospitalOtherServicesList />} />}
      />
      
      {/* Procedure Routes */}
      <Route
        path="/list-procedures"
        element={<ProtectedRoute element={<ProcedureList />} />}
      />
      <Route
        path="/add-procedure"
        element={<ProtectedRoute element={<AddProcedure />} />}
      />
      <Route
        path="/procedure-faq-list"
        element={<ProtectedRoute element={<ProcedureFaqList />} />}
      />

      <Route
        path="/regulatory-compliance"
        element={<ProtectedRoute element={<RegulatoryCompliance />} />}
      />


      {/* <Route path="*" element={<Login />} /> */}
      <Route path="*" element={<RedirectOnInvalidRoute />} />
    </Routes>
  );
};

export default AppRoutes;
